import React from 'react';
import { ArrowRight } from 'lucide-react';

const HeroSection = () => {
  const handleAgendarClick = () => {
    const element = document.getElementById('contato');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1494459940152-1e911caa8cc5?w=1920&q=80"
          alt="Peaceful background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-blue-900/70 via-blue-800/60 to-blue-900/70"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-32 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight animate-fade-in">
            Você não é seu passado.
            <br />
            <span className="text-blue-200">Você não é sua dor.</span>
          </h1>
          <p className="text-xl md:text-2xl text-blue-50 mb-8 leading-relaxed max-w-3xl mx-auto">
            Chegou a hora de reescrever sua história com coragem, consciência e profundidade.
          </p>
          <p className="text-lg md:text-xl text-blue-100 mb-12">
            Agende sua sessão e liberte o que te impede de viver por inteiro.
          </p>
          <button
            onClick={handleAgendarClick}
            className="inline-flex items-center bg-white text-blue-900 px-8 py-4 rounded-full text-lg font-semibold hover:bg-blue-50 transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 group"
          >
            Agendar Sessão
            <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="animate-bounce">
          <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
            <div className="w-1.5 h-3 bg-white/50 rounded-full"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;